/** Kinematic data upload page */
import { IonCol, IonGrid, IonRow } from '@ionic/react';

// Components
import { SessionReportCard } from '@/components/Cards';
import { Icon } from '@/components/Icon';
import { IconRotate, IconSize } from '@/components/Icon/types';
// Styles
import styles from '@/components/SessionSection/SessionSection.module.css';

import { convertDate } from '@/utils/convertFirebaseDate';
import { mergeClassNames } from '@/utils/mergeClassNames';

// Hooks
import { FirebaseTimestamp, Session } from '@/models';

interface SessionSectionProps {
  session: Session;
  sessionIndex: number;
  isActive: boolean;
  onToggle: () => void;
}

export const SessionSection = ({ session, sessionIndex, isActive, onToggle }: SessionSectionProps) => {
  const sessionDate = convertDate(session.date as FirebaseTimestamp);

  return (
    <div className={styles.SessionSection}>
      <IonGrid className='ion-no-padding' fixed>
        <IonRow className={styles.sessionSectionHeader}>
          <IonCol size='11'>
            <span className={styles.sessionTitle}>{`Session ${sessionIndex + 1}: `}</span>{' '}
            <span className={styles.sessionDate}>{sessionDate}</span>
          </IonCol>
          <IonCol className='ion-text-end' onClick={onToggle} size='1'>
            <Icon
              color='#829696'
              direction={isActive ? IconRotate.North : IconRotate.South}
              name='chevron'
              size={IconSize.medium}
            />
          </IonCol>
        </IonRow>

        {isActive && session.reportInfo && Object.keys(session.reportInfo).length > 0 && (
          <>
            {Object.keys(session.reportInfo).map((key: any, index: number, array: string[]) => (
              <IonRow
                className={mergeClassNames(
                  styles.contentWrapper,
                  isActive ? styles.open : '',
                  array.length > 1 && index !== array.length - 1 ? styles.marginBottom : '',
                )}
                key={key}>
                <IonCol size='12'>
                  <SessionReportCard
                    date={new Date(session.reportInfo![key].uploadTimestamp)}
                    id={session.reportInfo![key].id ?? ''}
                    name={session.reportInfo![key].reportName}
                    reportInfo={session.reportInfo![key]}
                    reportType={session.reportInfo![key].reportType}
                    tags={session.reportInfo![key].tags}
                  />
                </IonCol>
              </IonRow>
            ))}
          </>
        )}
      </IonGrid>
    </div>
  );
};
